import TooltipText from "@mui/material/Tooltip";
const Label = ({ title, required, view, Tooltip }: any) => {
  return (
    <TooltipText title={Tooltip ? title : ""}>
      <span
        className={
          required ? "required form-label" : view ? "lite-text" : "form-label"
        }
      >
        {title}
      </span>
    </TooltipText>
  );
};

export default Label;
